import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightbulb16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.46973 6.5304L7.11618 8.17681C7.15863 8.21925 7.20337 8.25801 7.25 8.29307V10H8.75V8.29315C8.79667 8.25807 8.84145 8.21929 8.88393 8.17681L10.5304 6.5304L9.46972 5.46973L8.00005 6.93936L6.53037 5.46973L5.46973 6.5304Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.91487 1.90001C4.96636 0.911585 6.40915 0.392883 7.99997 0.392883C9.59079 0.392883 11.0336 0.911584 12.0851 1.9C13.1423 2.89374 13.75 4.31239 13.75 6.00006C13.75 6.67656 13.4999 7.33461 13.1982 7.9212C12.8975 8.50597 12.5028 9.09792 12.1371 9.64653L12.124 9.6661C11.7434 10.237 11.3939 10.7629 11.1357 11.265C10.8749 11.7721 10.75 12.1766 10.75 12.5001V15.0001C10.75 15.4143 10.4142 15.7501 10 15.7501H6C5.58579 15.7501 5.25 15.4143 5.25 15.0001V12.5001C5.25 12.1766 5.12511 11.7721 4.86428 11.265C4.6061 10.7629 4.25657 10.237 3.87596 9.6661L3.86293 9.64655C3.49717 9.09793 3.10252 8.50598 2.80178 7.9212C2.50011 7.33461 2.25 6.67656 2.25 6.00006C2.25 4.3124 2.85772 2.89375 3.91487 1.90001ZM4.94225 2.99294C4.2137 3.67779 3.75 4.68772 3.75 6.00006C3.75 6.32356 3.87489 6.72802 4.13572 7.23518C4.3939 7.73721 4.74343 8.26314 5.12404 8.83405L5.13709 8.85363C5.50284 9.40224 5.89748 9.99417 6.19822 10.5789C6.38683 10.9457 6.55528 11.3404 6.65506 11.75H9.34494C9.44472 11.3404 9.61317 10.9457 9.80178 10.5789C10.1025 9.99418 10.4972 9.40224 10.8629 8.85364L10.876 8.83405C11.2566 8.26314 11.6061 7.73721 11.8643 7.23518C12.1251 6.72802 12.25 6.32356 12.25 6.00006C12.25 4.68773 11.7863 3.67779 11.0577 2.99294C10.3235 2.30277 9.2663 1.89288 7.99997 1.89288C6.73365 1.89288 5.67645 2.30277 4.94225 2.99294ZM9.25 13.25H6.75V14.2501H9.25V13.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lightbulb16.displayName = 'Lightbulb16';
export default Lightbulb16;
